import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
})
export class TextAreaComponent implements OnInit {
  textAreaNgModel = '' as string;
  textAreaDisabledNgModel = '' as string;
  textAreaFormControl = new FormControl('');
  form!: FormGroup;
  maxLength: number = 200;
  textAreaId5 = '' as string;
  textAreaId6 = '' as string;
  submitted = false as boolean;
  isBrowser = true as boolean;
  paramsSubscription!: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) public platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else {
      this.isBrowser = false;
    }
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      textArea: ['', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+')]]
    });

    this.paramsSubscription = this.route.queryParams.subscribe(param => {
      if (param['textAreaId5']) {
        this.textAreaId5 = param['textAreaId5'];
      }
      if (param['textAreaId6']) {
        this.textAreaId6 = param['textAreaId6'];
      }
    });
  }

  ngOnDestroy() {
    if (this.paramsSubscription) {
      this.paramsSubscription.unsubscribe();
    }
  }
}